export default __webpack_public_path__ + "static/media/gallery-wip-connection-rods_02.64504e1c.jpg";